<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item :label="$t('groupmanage.gname')">
        <el-input :placeholder="$t('groupmanage.placeholder')" v-model="filter.groupName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button   icon="el-icon-plus" type="success"
          @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
      <el-table-column label="社区名" prop="name" align="center"></el-table-column>
      <el-table-column label="所属街道" prop="street_name" align="center"></el-table-column>
      <el-table-column label="创建时间" prop="create_time" align="center"></el-table-column>
      <el-table-column label="修改时间" prop="modify_time" align="center"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="240px" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">编辑</el-button>
          <el-button type="text"   @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增or修改街道 -->
    <el-dialog :visible.sync="visible.editGroup" :title="isUpdate ? $t('groupmanage.editortitle') : $t('groupmanage.appendtitle')" width="1000px">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="groupForm">
            <el-form-item label="社区名" prop="name" label-width="20%">
              <el-input placeholder="请输入社区名" v-model="form.name" maxlength="30" show-word-limit />
            </el-form-item>
            <el-form-item label="所属街道" prop="street_id" label-width="20%">
              <el-select v-model="form.street_id" @change="handleStreetChange" placeholder="请选择所属街道" style="width: 100%" clearable filterable>
                <el-option v-for="item in streetOptions" :key="item.ID" :label="item.name" :value="item.ID">
                  <span style="float: left">{{ item.name }}</span>
                  <!-- <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ item.province }}{{ item.city }}{{ item.region }}
                  </span> -->
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="remark" label-width="20%">
              <el-input placeholder="请输入备注" v-model="form.remark" />
            </el-form-item>
            <!-- <el-form-item :label="$t('groupmanage.table.platformLogo')" prop="platformLogo" label-width="20%">
              <file-upload listType="picture-card" :limit="1" @fileChange="fileChange" field="platformLogo" :fileList="form.platformLogo"></file-upload>
            </el-form-item> -->
            <!-- <el-form-item label="主题" prop="platformTheme">
              <el-select v-model="form.platformTheme">
                <el-option label="浅色" :value="1"></el-option>
                <el-option label="深色" :value="2"></el-option>
              </el-select>
            </el-form-item> -->
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="visible.editGroup = false">{{ $t("groupmanage.cancelbtn") }}</el-button>
        <el-button type="primary" @click="onSubmit">{{ $t("groupmanage.confirmbtn") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { getCommunityList, modifyCommunity, delCommunity, addCommunity, getStreetPageList } from "@/api/dev_archive"
import { mapGetters } from "vuex"
export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { fileUpload },
  data() {
    return {
      detailForm: {},
      detailVisible: false,
      visible: {
        editGroup: false
      },
      tableData: [],
      form: {
        name: "",
        street_id: "",
        remark: ""
      },
      streetOptions: [],
      formRules: {},
      filter: {
        groupName: ""
      },
      loading: false,
      isUpdate: true,
      gid: "" //街道id
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.formRules = {
      street_id: [{ required: true, message: "请选择所属街道", trigger: "change" }],
      name: [{ required: true, message: "请输入社区名", trigger: "change" }]
    }
    // 加载街道数据并初始化表格数据
    this.loadStreetOptions().then(() => {
      this.getData()
    })
  },
  methods: {
    handleStreetChange(value) {
      console.log("选择了街道:", value)

      // 可以根据 value 查找对应的街道信息
      if (value) {
        const selectedStreet = this.streetOptions.find((item) => item.ID === value)
        console.log("选择的街道详细信息:", selectedStreet)
      } else {
        console.log("清空了选择")
      }

      // 或者直接输出当前表单的值
      console.log("当前表单 street_id 值:", this.form.street_id)
    },
    // 加载街道选项并返回Promise
    loadStreetOptions() {
      return getStreetPageList()
        .then((res) => {
          if (res && res.data) {
            this.streetOptions = res.data.filter((item) => !item.del)
            return this.streetOptions
          }
          return []
        })
        .catch((error) => {
          console.error("加载街道列表失败:", error)
          this.$message.error("加载街道列表失败")
          return []
        })
    },

    // 修改：确保街道数据已加载
    async onUpdate(row) {
      console.log("编辑行数据:", row)
      console.log("street_id:", row.street_id)
      console.log("street_name:", row.street_name)
      console.log("当前街道选项:", this.streetOptions)

      // 确保街道数据已加载
      if (!this.streetOptions.length) {
        await this.loadStreetOptions()
      }

      // 查找匹配的街道
      const matchedStreet = this.streetOptions.find((item) => item.ID === row.street_id)
      console.log("匹配的街道:", matchedStreet)

      this.visible.editGroup = true
      this.isUpdate = true
      this.form.name = row.name
      this.form.street_id = row.street_id
      this.form.remark = row.remark
      this.gid = row.ID

      // 使用 $nextTick 确保下拉框已渲染
      this.$nextTick(() => {
        console.log("表单数据设置完成:", this.form)
      })
    },

    fileChange(fileList, field) {
      this.form[field] = fileList
    },
    onDetail(row) {
      this.detailForm = { ...row }
      this.detailVisible = true
    },
    onDelete(row) {
      this.$confirm("确定要删除该社区吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delCommunity(row).then((res) => {
            this.$message.success(`删除成功`)
            this.toFilter()
          })
        })
        .catch(() => {
          // 取消删除
        })
    },
    getData() {
      this.loading = true
      getCommunityList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        name: this.filter.groupName || null
      })
        .then((res) => {
          // 创建街道映射表
          const streetMap = {}
          this.streetOptions.forEach((street) => {
            streetMap[street.ID] = street.name
          })

          // 处理表格数据 - 保持原始 street_id 不变，添加 street_name 用于显示
          this.tableData = res.data.map((item) => {
            return {
              ...item,
              street_name: streetMap[item.street_id] || item.street_id
            }
          })
          this.pageParams.total = res.total

          console.log("表格数据:", this.tableData)
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 修改：确保街道数据已加载
    async onAdd() {
      this.visible.editGroup = true
      this.isUpdate = false
      this.form = this.$options.data().form

      // 确保街道数据已加载
      if (!this.streetOptions.length) {
        await this.loadStreetOptions()
      }
    },

    onSubmit() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()
          const reqData = {
            name: this.form.name,
            street_id: this.form.street_id,
            remark: this.form.remark
          }
          if (this.isUpdate) {
            reqData.ID = this.gid
            modifyCommunity(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.modifiedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          } else {
            addCommunity(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.addedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
</style>
